import { useRef } from "react";
import { Navigate, useNavigate } from "react-router-dom";

// formik component
import { Formik, Form, ErrorMessage } from "formik";

//Prime React Components
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Toast } from "primereact/toast";

//Buffer Storage
import { Buffer } from "buffer";

//API Constant Settings
import { LOGIN } from "../../config/ApiConstant";
import axiosInstance from "../../config/axiosInstance";

// formik login validation Schema
import { loginSchema } from "../../config/Validate";

// Define type for the login form
import { LoginType } from "../../appconfig/interfaces";

// login form initial values
const initialValues: LoginType = {
  email: "",
  password: "",
};

export const Login = () => {
  document.title = "Login | Agriown";

  // set Toast
  const toast = useRef<any>(null);

  // hook for navigation
  const navigate = useNavigate();

  // Get the token from localStorage
  const login = localStorage.getItem("token");

  // If token is found, redirect user to dashboard
  if (login) {
    return <Navigate to="/dashboard" replace />;
  }

  // form submit handler
  const onSubmit = async (values: LoginType) => {
    try {
      // payload
      const payload: LoginType = {
        email: values.email,
        password: Buffer.from(values.password).toString("base64"),
      };

      //API Call
      const response = await axiosInstance.post(LOGIN, payload);

      //Get API Response
      if (response) {
        // get Data for response
        const { token, user_data } = response.data.data;

        const usertoken = token;

        //After Success Login Set Token in Common
        axiosInstance.defaults.headers.common["Authorization"] =
          "Bearer " + usertoken;

        localStorage.setItem("user_data", JSON.stringify(user_data));

        //set localstorage
        localStorage.setItem("token", usertoken);

        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.data.message,
        });

        setTimeout(() => {
          navigate("/dashboard");
        }, 500);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error.response.data.error,
      });
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="login-body">
        <div className="login-panel p-fluid">
          <div className="w-full">
            <div className="logo-container">
              <img
                src="/assets/images/agri-own-logo.png"
                className="login-logo"
                alt="login-logo"
              />
            </div>

            <div className="mt-1 login-form form-container">
              <Formik
                initialValues={initialValues}
                validationSchema={loginSchema}
                onSubmit={onSubmit}
              >
                {({
                  values,
                  handleChange,
                  errors,
                  isSubmitting,
                  touched,
                  handleBlur,
                }) => (
                  <Form>
                    <div className="field">
                      <span className="p-input-icon-left">
                        <i className="pi pi-envelope"></i>
                        <InputText
                          id="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Email"
                          className="w-full"
                        />
                      </span>
                      <small className="p-invalid-txt d-flex">
                        <ErrorMessage name="email" />
                      </small>
                    </div>

                    <div className="field">
                      <span className="p-input-icon-left">
                        <i className="pi pi-key"></i>
                        <Password
                          id="password"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          placeholder="Password"
                          onBlur={handleBlur}
                          toggleMask
                          feedback={false}
                          className="w-full"
                        />
                      </span>
                      <small className="p-invalid-txt d-flex">
                        <ErrorMessage name="password" />
                      </small>
                    </div>

                    <div className="button-container">
                      <Button
                        type="submit"
                        className="login-btn"
                        label="Login"
                        loading={isSubmitting}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
